export { default } from './BookingsTable'
